import React, { useMemo } from "react";

/**
 * Subtle celestial star/sparkle field. Deterministic positions so it
 * doesn't reflow. Pure decoration.
 */
export default function StarField({ count = 26, className = "" }) {
    const stars = useMemo(() => {
        const arr = [];
        let seed = 7;
        const rand = () => {
            seed = (seed * 9301 + 49297) % 233280;
            return seed / 233280;
        };
        for (let i = 0; i < count; i++) {
            arr.push({
                top: rand() * 100,
                left: rand() * 100,
                size: 1 + rand() * 2.5,
                delay: rand() * 4,
                dur: 3 + rand() * 3,
            });
        }
        return arr;
    }, [count]);

    return (
        <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
            {stars.map((s, i) => (
                <span
                    key={i}
                    className="absolute rounded-full bg-alma-gold animate-twinkle"
                    style={{
                        top: `${s.top}%`,
                        left: `${s.left}%`,
                        width: `${s.size}px`,
                        height: `${s.size}px`,
                        animationDelay: `${s.delay}s`,
                        animationDuration: `${s.dur}s`,
                        boxShadow: "0 0 6px rgba(201,162,75,0.7)",
                    }}
                />
            ))}
        </div>
    );
}
